<template>
  <v-app>
    <v-navigation-drawer persistent :mini-variant="miniVariant" :width="200" :clipped="clipped" v-model="drawer" enable-resize-watcher disable-resize-watcher fixed app>
      <v-list>
        <v-list-tile value="true" v-for="(item, i) in items" :key="i" :to="{path: item.path}">
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile value="true">
          <v-list-tile-content>
            <v-list-tile-title @click="handleLogin()" v-if="!isLogin">基金客户登入</v-list-tile-title>
            <v-list-tile-title @click="logout()" v-else>基金客户登出</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile value="true" :to="{path: '/account'}">
          <v-list-tile-content>
            <v-list-tile-title v-if="isLogin">会员中心</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>
    </v-navigation-drawer>
    <v-toolbar absolute color="rgba(255, 255, 255, 0.0)" dark scroll-off-screen scroll-target="#scrolling-techniques" flat app>
      <v-toolbar-side-icon class="hidden-md-and-up" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>

        <v-spacer></v-spacer>

      </v-toolbar-title>
      <v-toolbar-items class="hidden-sm-and-down header">
        <v-btn flat to="/">
          <img src="../public/images/logo.png" style="height:40px;width:120px">
        </v-btn>
        <v-btn flat to="/about">关于</v-btn>
        <v-btn flat to="/hotel">海外资产运营</v-btn>
        <v-btn flat to="/fund">海外资产配置</v-btn>
        <v-btn flat to="/travel">海外生活体验</v-btn>
        <v-btn flat to="/contact">联系我们</v-btn>
        <v-btn flat @click="handleLogin()" v-if="!isLogin">基金客户登入</v-btn>
        <v-btn flat @click="logout()" v-else>基金客户登出</v-btn>
        <v-btn flat v-if="isLogin" to="/account" class="account" style="background: #94949494;padding: 5px;">会员中心</v-btn>

      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <nav-bar />
      <router-view v-if="isRouterAlive" />
    </v-content>
    <v-navigation-drawer temporary :right="right" fixed app>
      <v-list>
        <v-list-tile @click="right = !right">
          <v-list-tile-action>
            <v-icon>compare_arrows</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Switch drawer (click me)</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <footer-bar />
    <!-- <v-footer app>
      <span>2018</span>
    </v-footer> -->

    <v-dialog v-model="login_dialog" width="600px">
      <v-tabs dark slider-color="yellow" fixed-tabs>
        <v-tab ripple>
          会员登入
        </v-tab>
        <v-tab-item>
          <a-card>
            <a-form :form="form1">
              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="手机" has-feedback>
                <a-input v-decorator="['phone',{rules: [{ required: true, message: '手机为必填项目' }, {min: 11, message: '手机号码为11码'}]}]" placeholder="请输入手机" maxlength="11">
                  <div slot="addonBefore">+86</div>
                </a-input>
              </a-form-item>

              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="密码" has-feedback>
                <a-input type="password" v-decorator="['password',{rules: [{ required: true, message: '密码为必填项目' }]}]" placeholder="请输入密码" />
              </a-form-item>

              <div style="text-align: right">
                <a-button class=" btn" type="primary" @click="forget()" ghost>忘记密码?</a-button>
                <a-button class="btn" type="primary" @click="login()" :loading="loading">登入</a-button>
              </div>
            </a-form>
          </a-card>
        </v-tab-item>

        <v-tab ripple>
          会员注册
        </v-tab>
        <v-tab-item>
          <a-card>
            <a-form :form="form2">
              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="姓名" has-feedback>
                <a-input v-decorator="['name',{rules: [{ required: true, message: '姓名为必填项目' }]}]" placeholder="请输入姓名" maxlength="10">
                </a-input>
              </a-form-item>

              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="手机" has-feedback>
                <a-input v-decorator="['phone',{rules: [{ required: true, message: '手机为必填项目' }, {min: 11, message: '手机号码为11码'}]}]" placeholder="请输入手机" maxlength="11">
                  <div slot="addonBefore">+86</div>
                </a-input>
              </a-form-item>

              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="密码" has-feedback>
                <a-input type="password" v-decorator="['password',{rules: [{ required: true, message: '密码为必填项目' }]}]" placeholder="请输入密码" />
              </a-form-item>

              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="确认密码" has-feedback>
                <a-input type="password" v-decorator="['checkPass',{rules: [{ required: true, message: '确认密码为必填项目' }, {validator: compareToFirstPassword}]}]" @blur="handleConfirmBlur" placeholder="再一次输入密码" />
              </a-form-item>

              <div style="text-align: right">
                <a-button type="primary" @click="register()" :loading="register_loading">注册</a-button>
              </div>
            </a-form>
          </a-card>
        </v-tab-item>
      </v-tabs>
    </v-dialog>

    <v-dialog v-model="verify_dialog" width="600px">
      <v-tabs dark slider-color="yellow" fixed-tabs>
        <v-tab ripple>
          手机验证
        </v-tab>
        <v-tab-item>
          <a-card>
            <a-form :form="form4">
              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="验证码" has-feedback>
                <a-input v-decorator="['verify',{rules: [{ required: true, message: '验证码为必填项目' }, {min: 4, message: '验证码为4码'}]}]" placeholder="请输入验证码" maxlength="4">
                </a-input>
              </a-form-item>

              <div style="text-align: right">
                <a-button type="primary" @click="memberVerify()" :loading="send_loading">发送验证码</a-button>
              </div>
            </a-form>
          </a-card>
        </v-tab-item>
      </v-tabs>
    </v-dialog>

    <v-dialog v-model="forget_dialog" width="600px">
      <v-tabs dark slider-color="yellow" fixed-tabs>
        <v-tab ripple>忘记密码</v-tab>
        <v-tab-item>
          <a-card>
            <a-form :form="form3">
              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="手机" has-feedback>
                <a-input v-decorator="['phone',{rules: [{ required: true, message: '手机为必填项目' }, {min: 11, message: '手机号码为11码'}]}]" placeholder="请输入手机" maxlength="11">
                  <div slot="addonBefore">+86</div>
                </a-input>
              </a-form-item>

              <div style="text-align: right">
                <a-button type="primary" @click="sendSms()" :loading="send_loading">发送验证码</a-button>
              </div>
            </a-form>
          </a-card>
        </v-tab-item>
      </v-tabs>
    </v-dialog>

    <v-dialog v-model="verify_dialog2" width="600px">
      <v-tabs dark slider-color="yellow" fixed-tabs>
        <v-tab ripple>
          手机验证
        </v-tab>
        <v-tab-item>
          <a-card>
            <a-form :form="form5">
              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="验证码" has-feedback>
                <a-input v-decorator="['verify',{rules: [{ required: true, message: '验证码为必填项目' }, {min: 4, message: '验证码为4码'}]}]" placeholder="请输入验证码" maxlength="4">
                </a-input>
              </a-form-item>

              <div style="text-align: right">
                <a-button type="primary" @click="memberVerify2()" :loading="send_loading">发送验证码</a-button>
              </div>
            </a-form>
          </a-card>
        </v-tab-item>
      </v-tabs>
    </v-dialog>

    <v-dialog v-model="reset_dialog" width="600px">
      <v-tabs dark slider-color="yellow" fixed-tabs>
        <v-tab ripple>
          重设密码
        </v-tab>
        <v-tab-item>
          <a-card>
            <a-form :form="form6">
              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="密码" has-feedback>
                <a-input type="password" v-decorator="['password',{rules: [{ required: true, message: '密码为必填项目' }]}]" placeholder="请输入密码" />
              </a-form-item>

              <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="确认密码" has-feedback>
                <a-input type="password" v-decorator="['checkPass',{rules: [{ required: true, message: '确认密码为必填项目' }, {validator: compareToFirstPassword2}]}]" @blur="handleConfirmBlur" placeholder="再一次输入密码" />
              </a-form-item>

              <div style="text-align: right">
                <a-button type="primary" @click="resetPassword()" :loading="register_loading">重设密码</a-button>
              </div>
            </a-form>
          </a-card>
        </v-tab-item>
      </v-tabs>
    </v-dialog>
  </v-app>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import FooterBar from '@/components/FooterBar.vue'
import { mapGetters, mapActions } from 'vuex'
import Cookies from 'js-cookie'

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 }
}

export default {
  name: 'App',
  components: {
    NavBar,
    FooterBar
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      formItemLayout,
      form1: this.$form.createForm(this), // 登入
      form2: this.$form.createForm(this), // 註冊
      form3: this.$form.createForm(this), // 忘記密碼
      form4: this.$form.createForm(this), // 驗證
      form5: this.$form.createForm(this), // 驗證重設密碼
      form6: this.$form.createForm(this), // 重設密碼
      isRouterAlive: true,
      clipped: false,
      drawer: false,
      fixed: false,
      items: [
        { icon: '', title: '首页', path: '/' },
        { icon: '', title: '关于', path: '/about' },
        { icon: '', title: '海外资产运营', path: '/hotel' },
        { icon: '', title: '海外资产配置', path: '/fund' },
        { icon: '', title: '海外生活体验', path: '/travel' },
        { icon: '', title: '联系我们', path: '/contact' }
      ],
      miniVariant: false,
      right: true,
      title: 'CANAAN',

      login_dialog: false,
      verify_dialog: false,
      verify_dialog2: false,
      forget_dialog: false,
      reset_dialog: false,

      device: 'desktop',
      isLogin: this.$store.state.front.isLogin,
      valid: true,
      temp: {
        name: '',
        phone: '',
        password: ''
      },

      phone: '',

      verifyRules: [v => !!v || '验证码必填项目'],

      loading: false,
      register_loading: false,
      send_loading: false
    }
  },
  computed: mapGetters({
    fundInfo: 'fundInfo',
    saleFundInfo: 'saleFundInfo',
    catelog: 'catelog',
    userInfo: 'userInfo',
    registerData: 'registerData',
    verifyData: 'verifyData',
    announceByUser: 'announceByUser'
  }),
  created() {
    if (Cookies.get('member_id')) {
      this.$store
        .dispatch('MemberLogin', { token: Cookies.get('member_id') })
        .then(() => {
          if (this.userInfo.data) {
            this.$store.commit('isLogin', true)
            this.isLogin = this.$store.state.front.isLogin

            this.$store.dispatch('GetFundInfoByUser', this.userInfo.data)
            this.$store.dispatch('GetSaleFundInfoByUser', this.userInfo.data)
            this.$store.dispatch('GetAnnounceByUser', this.userInfo.data)
          }
        })
    } else {
      this.dialog = true
    }

    if (
      navigator.userAgent.indexOf('iPhone') > -1 ||
      navigator.userAgent.indexOf('Android') > -1
    ) {
      this.device = 'mobile'
    } else {
      this.device = 'desktop'
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    },
    register() {
      this.form2.validateFields((err, values) => {
        if (!err) {
          this.phone = values.phone
          this.register_loading = true

          this.$store.dispatch('MemberRegister', values).then(() => {
            console.log(this.registerData)
            if (this.registerData && this.registerData.status === 'success') {
              console.log(this.registerData.message)
              this.$message.success(this.registerData.message)
              this.verify_dialog = true
            } else {
              this.$message.error(this.registerData.message)
            }
            this.login_dialog = false
            this.register_loading = false
            this.form2.resetFields()
          })
        }
      })
    },
    resetPassword() {
      this.form6.validateFields((err, values) => {
        if (!err) {
          this.$store.dispatch('UpdatePassword', {
            password: values.password,
            phone: this.phone
          }).then(() => {
            this.$message.success('重设密码成功')
            this.reset_dialog = false
            this.form6.resetFields()
          })
        }
      })
    },
    handleConfirmBlur(e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form2
      if (value && value !== form.getFieldValue('password')) {
        callback('确认密码与密码不一致！')
      } else {
        callback()
      }
    },
    compareToFirstPassword2(rule, value, callback) {
      const form = this.form6
      if (value && value !== form.getFieldValue('password')) {
        callback('确认密码与密码不一致！')
      } else {
        callback()
      }
    },
    memberVerify() {
      this.form4.validateFields((err, values) => {
        if (!err) {
          this.$store
            .dispatch('MemberVerify', {
              verify: values.verify,
              phone: this.phone
            })
            .then(() => {
              if (this.verifyData.status === 'error') {
                this.$message.error(this.verifyData.message)
              } else {
                this.$message.success(this.verifyData.message)
              }
              this.verify_dialog = false
            })
        }
      })
    },
    memberVerify2() {
      this.form5.validateFields((err, values) => {
        if (!err) {
          console.log(values)
          this.$store
            .dispatch('MemberVerify', {
              verify: values.verify,
              phone: this.phone
            })
            .then(() => {
              if (this.verifyData.status === 'error') {
                this.$message.error(this.verifyData.message)
                this.verify_dialog2 = false
                this.reset_dialog = false
              } else {
                this.$message.success(this.verifyData.message)
                this.verify_dialog2 = false
                this.reset_dialog = true
              }
            })
        }
      })
    },
    handleLogin() {
      this.login_dialog = true
      this.form2.resetFields()
      this.form3.resetFields()
    },
    login() {
      this.form1.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('MemberLogin', values).then(() => {
            if (this.userInfo.status === 'error') {
              this.$message.error(this.userInfo.message)
              this.loading = false
            } else {
              this.$message.success(this.userInfo.message)

              this.$store.commit('isLogin', true)
              this.isLogin = this.$store.state.front.isLogin
              Cookies.set('member_id', this.userInfo.data.token)
              this.$store.dispatch('GetFundInfoByUser', this.userInfo.data)
              this.$store.dispatch('GetSaleFundInfoByUser', this.userInfo.data)
              this.$store.dispatch('GetAnnounceByUser', this.userInfo.data)
              this.loading = false
            }
            this.login_dialog = false
            this.form1.resetFields()
          })
        }
      })
    },
    logout() {
      Cookies.remove('member_id')
      this.userInfo.data = []
      this.$message.success('登出成功')

      this.$store.commit('isLogin', false)
      this.isLogin = this.$store.state.front.isLogin
      window.location.href = '/'
    },
    forget() {
      this.login_dialog = false
      this.forget_dialog = true
      this.form3.resetFields()
    },
    sendSms() {
      this.form3.validateFields((err, values) => {
        if (!err) {
          this.$store.dispatch('Recover', values).then(() => {
            this.phone = values.phone
            this.$message.success('重设密码信已寄出')
            this.forget_dialog = false
            this.verify_dialog2 = true
            this.form3.resetFields()
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.text {
  position: absolute;
  color: white;
  font-weight: 400;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>